module.exports = __webpack_public_path__ + "static/media/DagingKambing.25188faf.jpeg";